import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Barcode from "react-barcode";
import Logo from "../../logo.svg";
import { signInUser } from "../Utility/Auth";
import { resolvePhotoUrl } from "../Utility/resolvePhotoUrl";

const AccountHeader = ({ account, format, title }) => {
  const auth = signInUser();
  const { storeSettings } = auth || {};
  return (
    <>
      <div className="row pt-3 pb-3 mb-5 border-bottom">
        <div className="col-7">
          <img
            src={resolvePhotoUrl(
              storeSettings?.storePhoto || storeSettings?.photo,
              Logo
            )}
            onError={(e) => {
              e.target.src = Logo;
            }}
            height="40"
            alt="not Image"
          />
        </div>

        <div className="col-5">
          <p className="p-0 m-0 text-end">
            <b>Hotline: </b>{storeSettings?.phone}
          </p>
          <p className="p-0 m-0 text-end">
            <small>H#6, R#27, Sector 7, Uttara, Dhaka - 1230</small>{" "}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-6 print-header-text">
          {account?.supplier?.name ? (
            <p>
              <b>To</b>
              <br />
              {account?.supplier?.name} <br />
              {account?.supplier?.email} <br />
              {account?.supplier?.phone} <br />
              {account?.supplier?.address} <br />
            </p>
          ) : (
            <></>
          )}

          <p>
            <b>Form</b> <br />
            {storeSettings?.storeName || "No-Name"} <br />
            {storeSettings?.email || "No-Email"}
            <br />
            {storeSettings?.phone || "01700000000"}
            <br />
            {storeSettings?.address?.street || "No-Street"} ,
            {storeSettings?.address?.city || "No-City"},{" "}
            {storeSettings?.address?.state || "No-State"},{" "}
            {storeSettings?.address?.post || "No-PostalCode"} <br />
          </p>
        </div>
        <div className="col-6 text-end">
          <h4>{title}</h4>
          <span className="ps-6 d-block">
            <p>
              Account No: {account?.acId}
              <br />
              {/* PO No: {account?.poNo?.poNo} */}
              {/* <br /> */}
              Account Date:{" "}
              {account?.createdAt &&
                format(new Date(account?.createdAt), "yyyy-MM-dd")}{" "}
              <br />
              Account Time:{" "}
              {account?.createdAt &&
                format(new Date(account?.createdAt), "h:m:s aaa")}
              <br />
              Account Head:{" "}
              {account?.accountHead?.name ||
                account?.supplier?.company ||
                account?.supplier?.name ||
                account?.paymentType ||
                "-"}
              <br />
            </p>
            <p className="text-end bar-code">
              {account?._id ? (
                <Barcode
                  value={account._id}
                  height="60"
                  width="2"
                  fontSize="10"
                />
              ) : null}
            </p>
          </span>
        </div>
      </div>
    </>
  );
};

export default AccountHeader;
